import { API_URL } from "../../constants/axios";
import { fetchApi } from "../fetch";
import { Cookies } from "react-cookie";

export const getAccount = async () => {
  const res = await fetchApi.get(API_URL.ACCOUNT)

  if (res.status === 200) {
    return res.data;
  } else {
    return {};
  }
};

export const logout = () => {
  const cookies = new Cookies();
  cookies.remove("token", { path: "/" });
  localStorage.removeItem("channelState")
  window.location.href = "/login";
};

export const updateHostingPlatform = async (id, hostingName, hostingId, hostingPwd) => {
  const res = await fetchApi.post(API_URL.ACCOUNT_HOSTING, {
    id: id,
    hostingName: hostingName,
    hostingId: hostingId,
    hostingPwd: hostingPwd
  })

  if (res.status === 200) {
    return res.data;
  } else {
    return {};
  }
};

export const kakaoProfileChannelAuth = async (channelIdName, phoneNumber) => {
  try {
    const res = await fetchApi.post(API_URL.KAKAO_PROFILE_CHANNEL_AUTH, {
      channelIdName: channelIdName,
      phoneNumber: phoneNumber
    });
    if (res.status === 200) {
      return res.data;
    } else {
      return {};
    }
  } catch (e) {
    return e.response;
  }
};

export const channelAuthorization = async (channelIdName, phoneNumber, code) => {
  try {
    const res = await fetchApi.post(API_URL.CHANNEL_AUTHORIZATION, {
      channelIdName: channelIdName,
      phoneNumber: phoneNumber,
      code: code
    });
    if (res.status === 200) {
      return res.data;
    } else {
      return {};
    }
  } catch (e) {
    return e.response;
  }
};

export const postAgentRegistration = async (channelId, cardId, tier) => {
  const res = await fetchApi.post(API_URL.ACCOUNT_AGENT_REGISTRATION, {
    channelId: channelId,
    cardId: cardId,
    tier: tier
  })
  return res.data;
}

export const postConnectRegistration = async (channelId, hostingName, hostingId, hostingPwd, logoUrl, unitPrice, stickerType, bizRegNumber, concept) => {
  const res = await fetchApi.post(API_URL.ACCOUNT_CONNECT_REGISTRATION, {
    channelId, hostingName, hostingId, hostingPwd, logoUrl, unitPrice, stickerType, bizRegNumber, concept
  })
  return res.data;
}

export const getCredit = async () => {
  const res = await fetchApi.get(API_URL.ACCOUNT_CREDIT)
  return res.data;
}

export const postAutoChargeCredit = async (isOn, type, minCredit, chargeCredit) => {
  const res = await fetchApi.post(API_URL.ACCOUNT_AUTO_CHARGE_CREDIT, {
    isOn: isOn,
    type: type,
    minCredit: minCredit,
    chargeCredit: chargeCredit
  })
  return res.data;
}

export const getReservedCredits = async () => {
  const res = await fetchApi.get(API_URL.ACCOUNT_RESERVED_CREDIT)
  return res.data;
}

export const getChannelInfo = async (ids) => {
  const res = await fetchApi.get(API_URL.ACCOUNT_CHANNEL + `?ids=${ids.join(",")}`)
  if (res.status === 200) {
    return res.data;
  } else {
    throw new Error()
  }
}

/**
 * 채널 등록. `bizRegNumber` 는 2026-08-20 추가 — 서버가 채널 생성 시점에 사업자번호를 기록해
 * 고객이 중간에 이탈해도 '백엔드 연동'에서 연결할 계정을 찾을 수 있게 한다(숫자 10자리로 정규화됨).
 *
 * 서버는 같은 계정의 미완료 채널(발신프로필 없음)이 이미 있으면 새로 만들지 않고 그 채널을
 * 재사용하고, 이번 요청의 비어 있지 않은 값만 채워 넣는다.
 */
export const postChannelRegistration = async (channelName, channelIdName, profileKey, bizRegNumber) => {
  const res = await fetchApi.post(API_URL.ACCOUNT_CHANNEL, {
    channelName: channelName,
    channelIdName: channelIdName,
    profileKey: profileKey,
    bizRegNumber: bizRegNumber
  })
  return res.data;
}

/**
 * `/wizard` STEP 1·2 — 신청 접수.
 *
 * 🔴 **채널을 만들지 않는다.** 응답은 `channel_install_request.id` 이며 **채널 id 가 아니다** —
 * 이 값을 `localStorage.channelState`(= `Channel-Id` 헤더)에 넣으면 안 된다.
 * 그 자리는 채널 컨텍스트이고, 존재하지 않는 채널 id 를 넣으면 서버가 채널을 못 찾는다.
 */
export const postSignupChannel = async (channelName, channelIdName, profileKey, bizRegNumber, linkType) => {
  const res = await fetchApi.post(API_URL.ACCOUNT_INSTALL_REQUEST_CHANNEL, {
    channelName, channelIdName, profileKey, bizRegNumber, linkType
  })
  return res.data;
}

/**
 * `/wizard` 최종 제출 — 신청을 백엔드 연동 대기열에 올린다.
 *
 * 🔑 **채널 id 를 보내지 않는다.** 이 시점에 채널은 없고, 신청은 계정당 1건이라
 * 인증된 계정만으로 대상이 정해진다.
 * 🔑 스티커와 POP 을 **각각** 보낸다 — 둘 다 주문할 수 있다.
 */
export const postSignupSubmit = async (payload) => {
  const res = await fetchApi.post(API_URL.ACCOUNT_INSTALL_REQUEST_SUBMIT, payload)
  return res.data;
}

/*
  설치비 선결제 흐름(2026-10-12). 설계 = `_ai-runs/2026-10-12_001_signup_wizard_setup_fee_payment/`

  (4) 비치 방법 저장 → (5) 토스 카드 등록(페이지 이동) → (6) 견적 확인·결제.
  🔑 토스 왕복에서 React 상태가 사라지므로 (4) 가 먼저 서버에 저장하고, 돌아온 위저드는
     `getSignupRequest` 로 신청을 읽어 (6) 에서 이어간다.
*/

/** 로그인한 고객 자신의 신청(발췌). 없으면 `data` 가 null. */
export const getSignupRequest = async () => {
  const res = await fetchApi.get(API_URL.ACCOUNT_INSTALL_REQUEST)
  return res.data;
}

/**
 * 가격 상수표 + 현재 신청 기준 견적 + 기본 카드 + 결제 상태.
 * 🔑 가격은 서버만 안다 — 프론트에 금액 상수를 두지 말고 `data.pricing` 을 쓸 것.
 */
export const getSignupQuote = async () => {
  const res = await fetchApi.get(API_URL.ACCOUNT_INSTALL_REQUEST_QUOTE)
  return res.data;
}

/** (4) 비치 방법 + 연동 방식 저장. 상태는 바뀌지 않는다. */
export const postSignupPlacement = async (payload) => {
  const res = await fetchApi.post(API_URL.ACCOUNT_INSTALL_REQUEST_PLACEMENT, payload)
  return res.data;
}

/**
 * (6) 결제 실행. 🔴 **실제 카드 승인**이 올라간다. 금액은 보내지 않는다(서버 계산).
 * 실패도 200 으로 온다 — `data.result` 로 분기할 것('success'|'fail'|'no_card'|'already_paid'|'in_progress'|'no_request').
 */
export const postSignupPay = async () => {
  const res = await fetchApi.post(API_URL.ACCOUNT_INSTALL_REQUEST_PAY, {})
  return res.data;
}

export const postCounsel = async (name, phoneNumber, url, framework, isDeveloper, other, category) => {
  const res = await fetchApi.post(API_URL.ACCOUNT_COUNSEL, {
    name: name,
    phoneNumber: phoneNumber,
    url: url,
    framework: framework,
    isDeveloper: isDeveloper,
    category: category,
    other: other
  })
  return res.data;
}

export const postTermination = async (serviceName) => {
  const res = await fetchApi.post(API_URL.ACCOUNT_TERMINATION, {
    serviceName: serviceName,
  })
  return res.data;
}

export const getTier = async () => {
  const res = await fetchApi.get(API_URL.ACCOUNT_TIER)
  return res.data;
}

export const getServiceExpired = async () => {
  const res = await fetchApi.get(API_URL.ACCOUNT_SERVICE_EXPIRED)
  return res.data;
}

export const updateTier = async (tier) => {
  const res = await fetchApi.post(API_URL.ACCOUNT_TIER, {
    tier: tier
  })
  return res.data;
}

export const postRegistrationScreen = async (channelId, logoUrl, benefitConfig) => {
  const res = await fetchApi.post(API_URL.SIMPLE_SCREEN_REGISTRATION, {
    channelId: channelId,
    logoUrl: logoUrl,
    benefitConfig: benefitConfig
  })
  return res.data;
}

export const getSettings = async () => {
  const res = await fetchApi.get(API_URL.SETTINGS)
  return res.data;
}

export const saveSettings = async (phoneNumber, unitPrice) => {
  const res = await fetchApi.post(API_URL.SETTINGS, {
    phoneNumber: phoneNumber,
    unitPrice: unitPrice
  })
  return res.data;
}

export const reject = async (channelId, reason) => {
  const res = await fetchApi.post(API_URL.REJECT, {
    channelId: channelId,
    reason: reason
  })
  return res.data;
}

export const accept = async (channelId) => {
  const res = await fetchApi.post(API_URL.ACCEPT, {
    channelId: channelId
  })
  return res.data;
}